<template>
  <v-btn color="primary" dark outlined rounded @click="downloadReport"
    >Download Report</v-btn
  >
</template>
<script>
import { downloadFile } from "../../utils/download-utils";
export default {
  computed: {
    fileName() {
      return "SessionsBeforeFAD.csv";
    },
  },
  methods: {
    async downloadReport() {
      this.$store.commit("uxModule/setShowLoader", true);
      var response = await this.$store.dispatch(
        "reportsModule/getSessionsBeforeFADReport"
      );

      if (response) {
        await downloadFile(response, this.fileName);
      } else {
        this.$store.commit(
          "uxModule/setSnackbarMsg",
          "Oops! Something went wrong. Please try again later."
        );
        this.$store.commit("uxModule/setShowSnackbar", true);
      }
      this.$store.commit("uxModule/setShowLoader", false);
    },
  },
};
</script>
